import Header from "../../componants/header";
import Footer from "../../componants/footer";
import BannerForAll from "../../componants/bannerForAll";
import mernStackImage from '../../images/cardpageimages/technicalcourse/mernstackimage.jpg';
import IntroVideos from "../../componants/introvideos";
import MernStackModule from "../../componants/allCourseModule/TechnicalCourseModule/MernStackModule";

function MernStack() {
  return (
    <>
      <Header />
      <BannerForAll
        title="MERN STACK FULL COURSE"
        text="Our MERN Stack Full Course provides in-depth training in MongoDB, Express.js, React, and Node.js. Learn to build powerful and responsive full-stack applications from scratch, with a focus on both front-end and back-end development. Ideal for aspiring full-stack developers, this course prepares you to create, deploy, and maintain web applications using the MERN stack."
        imageone={mernStackImage}
        imagetwo={mernStackImage}
      />
      <IntroVideos
        vone="https://www.youtube.com/embed/dQw4w9WgXcQ"
        vtwo="https://www.youtube.com/embed/3JZ_D3ELwOQ"
        topic="MERN STACK"
      />
      <MernStackModule />
      <Footer />
    </>
  );
}

export default MernStack;
